import React, { useEffect, useState } from "react";

export default function ComingSoon() {
  

  return (
    <>
    

      <div className="coming-soon-container">
      <img
        src="assets/img/comingsoon.jpg"
        alt="Coming Soon"
        className="coming-soon-img"
      
      />
    </div>
    </>
  );
}
